import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useResize } from '../../hooks/resize';
import withAuthentication from '../commonComponent/others/_withAuthentication';
import { Header } from './Header';
import { SideTab } from './SideTab';
import { useSession } from '../../hooks/session';

interface Props {}

const Home: React.FC<Props> = () => {
  const location = useLocation();
  const { ref, isMobile } = useResize();
  const { loginVal, session } = useSession();
  const [openNav, setOpenNav] = useState<boolean>(true);
  const [param, setParam] = useState<string>('대시보드');
  const SettingParam = (newParam: string) => {
    switch (newParam) {
      case 'users':
        return '사용자 목록';
      case 'schools':
        return '학교 관리';
      case 'books':
        return '도서 관리';
      case 'classstat':
        return '학급 통계';
      case 'schoolstat':
        return '학교 통계';
      case 'educationofficestat':
        return '교육지원청 통계';
      case 'portalstat':
        return '전체 통계';
      default:
        return '';
    }
  };
  useEffect(() => {
    const newParam = location.pathname.split('/')[1];
    const newTitle =
      loginVal.value.user.roleName === '일반' ||
      loginVal.value.user.roleName === '관리자1'
        ? '학교 관리'
        : '도서 관리';
    setParam(newParam === '' ? newTitle : SettingParam(newParam));
    if (isMobile()) setOpenNav(false);
  }, [location.pathname]);

  useEffect(() => {
    if (isMobile()) setOpenNav(false);
    else setOpenNav(true);
  }, [isMobile()]);

  return (
    <div ref={ref}>
      <Header openNav={openNav} setOpenNav={setOpenNav} param={param} />
      <SideTab openNav={openNav} setOpenNav={setOpenNav} param={param} />
    </div>
  );
};

export default Home;
// export default withAuthentication(Home);
